import axios from 'axios';
import { getDomainAndPort } from '../api/Utils';
import { KeyValue } from './AdmitInfoPanel';
import notify from '../components/Notify';
import { isANumber } from '../utils/number';

interface RequestInfo {
  token: string;
  body: any;
  instance?: number;
}

const admitCapacityRequest: RequestInfo = {
  token:
    'tECL3T2gYEWgjZUVzsGBO9Xr3pskRcfxUO9WGd/Yjs3fBQkpAvUu15u1HYWXKjlW72UYvEWfRY63IVAnZyoSsSyyIR/HwtNC2RK9OYtxWoI=',
  body: {
    filters: [
      {
        type: 'dateRangeFilter',
        field: 'effectiveDate',
        start: 1553113800000,
        end: 2647808199999,
      },
    ],
    buckets: [
      {
        name: 'TermByAnswers',
        type: 'bucket',
        subBuckets: [],
        field: 'allAnswers',
        includeTotal: false,
        prefix: '352532355524116',
      },
    ],
    metrics: [{ metric: 'sum', field: 'scoreSum', name: 'result' }],
  },
};
const admitFilledToday: RequestInfo = {
  instance: 1240,
  token:
    'oTciCxGWj1CUpP3l1B2FA9Xr3pskRcfxUO9WGd/Yjs3fBQkpAvUu15u1HYWXKjlW72UYvEWfRY63IVAnZyoSsSyyIR/HwtNC2RK9OYtxWoI=',
  body: {
    filters: [
      {
        type: 'dateRangeFilter',
        field: 'effectiveDate',
        start: 1628537400000,
        end: 1628796599999,
      },
      { type: 'termFilter', field: 'questionId', values: [120190814392579] },
    ],
    buckets: [
      {
        name: 'TermByTime',
        type: 'dateRangeBucket',
        field: 'effectiveDate',
        start: null,
        end: null,
        includeTotal: false,
        gap: '+1DAYS',
        customField: {},
        subBuckets: [
          {
            name: 'TermByAnswers',
            type: 'bucket',
            subBuckets: [],
            field: 'allAnswers',
            includeTotal: true,
            prefix: '138042458751072',
          },
        ],
      },
    ],
    metrics: [{ metric: 'sum', field: 'scoreSum', name: 'result' }],
  },
};

const outpatientCapacityRequest: RequestInfo = {
  token:
    '04YVbDOcAxlL0nS85b7WntXr3pskRcfxUO9WGd/Yjs3fBQkpAvUu15u1HYWXKjlW72UYvEWfRY63IVAnZyoSsSyyIR/HwtNC2RK9OYtxWoI=',
  body: {
    filters: [
      {
        type: 'dateRangeFilter',
        field: 'effectiveDate',
        start: 1553113800000,
        end: 2647808199999,
      },
    ],
    buckets: [
      {
        name: 'TermByAnswers',
        type: 'bucket',
        subBuckets: [],
        field: 'allAnswers',
        includeTotal: false,
        prefix: '352532355524116',
      },
    ],
    metrics: [{ metric: 'sum', field: 'scoreSum', name: 'result' }],
  },
};
const outpatientTotalCapacityRequest: RequestInfo = {
  token:
    'JRh9hq0rbZE00d/GCANiZvTyyOfzLx/n5XfRV/e61NrfBQkpAvUu15u1HYWXKjlWNDkDW3E7v8mDIQiu5LjB4hnM2KcbLYNUjATv77U5ZnU=',
  body: {
    filters: [
      {
        type: 'dateRangeFilter',
        field: 'effectiveDate',
        start: 162948780000,
        end: 16295741999990,
      },
    ],
    buckets: [
      {
        name: 'TermByAnswers',
        type: 'bucket',
        subBuckets: [],
        field: 'allAnswers',
        includeTotal: false,
        prefix: '352532355524116',
      },
    ],
    metrics: [{ metric: 'avg', field: 'score', name: 'result' }],
  },
};
const outpatientFilledByDay: RequestInfo = {
  token:
    'BHB0x6SQmq++0svN75GBvNXr3pskRcfxUO9WGd/Yjs3fBQkpAvUu15u1HYWXKjlW72UYvEWfRY63IVAnZyoSsSyyIR/HwtNC2RK9OYtxWoI=',
  body: {
    filters: [
      {
        type: 'dateRangeFilter',
        field: 'effectiveDate',
        start: 1628191800000,
        end: 1628623799999,
      },
    ],
    buckets: [
      {
        name: 'TermByAnswers',
        type: 'bucket',
        subBuckets: [
          {
            name: 'TermByAnswers',
            type: 'bucket',
            subBuckets: [
              {
                name: 'TermByTime',
                type: 'dateRangeBucket',
                field: 'effectiveDate',
                start: null,
                end: null,
                includeTotal: false,
                gap: '+1DAYS',
              },
            ],
            field: 'allAnswers',
            includeTotal: false,
            prefix: '277518506689645',
          },
        ],
        field: 'allAnswers',
        includeTotal: false,
        prefix: '297848820735046',
      },
    ],
    metrics: [
      {
        metric: 'count',
        field: 'score',
        name: 'result',
      },
    ],
  },
};

const analyseUrl =
  getDomainAndPort().protocolDomain + '/man/rest/survey/analyse';
const responsesUrl =
  getDomainAndPort().protocolDomain + '/man/rest/survey/getAllResponses';

function exportData3d(data: any) {
  const ret: any = {};
  data.categories.TermByAnswers.buckets.forEach((e: any) => {
    const key = e.val.substring(e.val.indexOf('$$') + 2);
    const value = {};
    e.categories.TermByAnswers.buckets.forEach((e: any) => {
      const shift = e.val.substring(e.val.indexOf('$$') + 2);
      e.categories.TermByTime.buckets.forEach((e: any) => {
        const day = e.val;
        value[day + '$$' + shift] = e.metrics.result;
      });
    });
    ret[key] = value;
  });
  return ret;
}

function exportDat2d(data: any) {
  const ret: any = {};
  data.categories.TermByTime.buckets.forEach((e: any) => {
    const day = e.val;
    const value = {};
    e.categories.TermByAnswers.buckets.forEach((e: any) => {
      const key = e.val.substring(e.val.indexOf('$$') + 2);
      value[key] = e.metrics.result;
    });
    ret[day] = value;
  });
  return ret;
}
function exportData(data: any) {
  const ret: any = {};
  data.categories.TermByAnswers.buckets.forEach((e: any) => {
    ret[e.val.substring(e.val.indexOf('$$') + 2)] = e.metrics.result;
  });
  return ret;
}

async function fetchData(
  param: RequestInfo,
  fromDate?: number,
  toDate?: number
) {
  try {
    if (fromDate && toDate) {
      (param.body.filters[0].start = fromDate),
        (param.body.filters[0].end = toDate);
    }
    const res = await axios.post(analyseUrl, param.body, {
      params: { survey_token: param.token },
      headers: {
        allowCache: 'true',
        // 'Cache-Control': true,
      },
    });
    if (res.status === 200 && res.data.categories) {
      return res.data;
    }
    return {};
  } catch (err) {
    notify('error');
  }
}

let result: any = undefined;

export async function fetchEmptyCounts(): Promise<{
  admitCapacityInfo: KeyValue;
  admitFreeInfo: KeyValue;
  admitFilledInfo: KeyValue;
  outpatientCapacityInfo: KeyValue;
  outpatientTotalCapacityInfo: KeyValue;
  outpatientFreeInfo: KeyValue;
  baseOutpatientSortShift: string;
  shifts: string[];
  days: number[];
  currentDay: number;
  totalAdmit: number;
  currentShiftIndex: number;
  lastAdmitResponseTime: number;
}> {
  if (result) {
    return result;
  }
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const end = new Date();
  end.setHours(23, 59, 59, 999);

  const lastAdmitResponseTime = await axios
    .get(responsesUrl, {
      params: {
        survey_token: admitFilledToday.token,
        start: 0,
        count: 1,
        order: 'updateDate desc',
        instance: admitFilledToday.instance,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data[0].updateDate;
      }
      return 0;
    });

  const admitCapacityInfo: KeyValue = await fetchData(
    admitCapacityRequest
  ).then((data) => {
    return exportData(data);
  });

  const admitFilledInfo: KeyValue = await fetchData(
    admitFilledToday,
    start.getTime() - 30 * 24 * 60 * 60 * 1000,
    end.getTime()
  ).then((data) => {
    return exportDat2d(data);
  });
  // const admitFilledFallbackInfo: KeyValue = await fetchData(
  //   admitFilledToday,
  //   start.getTime() - 24 * 60 * 60 * 1000,
  //   end.getTime() - 24 * 60 * 60 * 1000
  // );
  const admitFreeInfo: KeyValue = {};
  const admitFinalFilledInfo: KeyValue = {};
  let totalFree = 0;
  let totalAdmit = 0;
  if (admitFilledInfo)
    Object.entries(admitCapacityInfo).forEach((v) => {
      const capacity = v[1] as number;
      const filled = Object.values(admitFilledInfo).reduce((prev, current) => {
        if (isANumber(current?.[v[0]])) {
          return Number(current?.[v[0]]);
        }
        return prev;
      }, capacity);
      // const filled = admitFilledInfo[v[0]] as number;
      // const filledFallback = admitFilledFallbackInfo[v[0]] as number;
      const finalFilled = filled as number;
      totalAdmit += finalFilled;
      admitFinalFilledInfo[v[0]] = finalFilled;
      admitFreeInfo[v[0]] = Math.max(0, capacity - finalFilled);
      totalFree += admitFreeInfo[v[0]] as number;
    });

  admitFreeInfo['total'] = totalFree;

  const outpatientFilledInfo = await fetchData(
    outpatientFilledByDay,
    start.getTime(),
    end.getTime() + 5 * 24 * 60 * 60 * 1000 - 1
  ).then((data) => {
    if (!data.categories) {
      return {};
    }
    return exportData3d(data);
  });
  const outpatientCapacityInfo: KeyValue = await fetchData(
    outpatientCapacityRequest
  ).then((data) => {
    return exportData(data);
  });
  const outpatientTotalCapacityInfo: KeyValue = await fetchData(
    outpatientTotalCapacityRequest
  ).then((data) => {
    return exportData(data);
  });
  const days = [0, 1, 2, 3, 4].map(
    (i) => start.getTime() + i * 24 * 60 * 60 * 1000
  );
  const shifts = [
    '۸-۱۰',
    '۱۰-۱۲',
    '۱۲-۱۴',
    '۱۴-۱۶',
    '۱۶-۱۸',
    '۱۸-۲۰',
    '۲۰-۲۲',
    '۲۲-۲۴',
  ];
  const currentShiftIndex = Math.max(
    Math.floor((new Date().getHours() - 8) / 2),
    0
  );
  const outpatientFreeInfo = {};
  const baseOutpatientSortShift = `${days[0]}$$${shifts[currentShiftIndex]}`;
  let outpatientTotal = 0;
  Object.keys(outpatientCapacityInfo).forEach((hospitalKey: string) => {
    outpatientFreeInfo[hospitalKey] = {};
    days.forEach((day) => {
      shifts.forEach((shift) => {
        const shiftKey = `${day}$$${shift}`;
        outpatientFreeInfo[hospitalKey][shiftKey] = Math.max(
          0,
          (outpatientCapacityInfo[hospitalKey] as number) -
            (outpatientFilledInfo?.[hospitalKey]?.[shiftKey] ?? 0)
        );
        if (shiftKey === baseOutpatientSortShift) {
          outpatientTotal += outpatientFreeInfo[hospitalKey][shiftKey];
        }
      });
    });
  });
  outpatientFreeInfo['total'] = outpatientTotal;

  result = {
    admitCapacityInfo,
    admitFreeInfo,
    admitFilledInfo: admitFinalFilledInfo,
    outpatientCapacityInfo,
    outpatientTotalCapacityInfo,
    outpatientFreeInfo,
    baseOutpatientSortShift,
    shifts,
    days,
    currentShiftIndex,
    totalAdmit,
    currentDay: days[0],
    lastAdmitResponseTime,
  };
  return result;
}
